var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVehicleButton(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Bot\\xF3n_veh\\xEDculo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_218",
    "data-name": "Rect\\xE1ngulo 218",
    width: 34,
    height: 34,
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_638",
    "data-name": "Rect\\xE1ngulo 638",
    width: 25.274,
    height: 14.985,
    transform: "translate(9)",
    fill: "#707070"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_293",
    "data-name": "Rect\\xE1ngulo 293",
    fill: "#e4e4e4",
    stroke: "#bfbfbf",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 32,
    height: 32,
    rx: 4,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_29",
    "data-name": "Enmascarar grupo 29",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_428",
    "data-name": "Grupo 428",
    transform: "translate(-4.637 9.881)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1054",
    "data-name": "Trazado 1054",
    d: "M34.807,6.458c-.407.448-.744.392-.984-.165-.095-.22-.178-.445-.288-.657-.04-.077-.141-.123-.238-.2v.928q0,2.561,0,5.122a1.274,1.274,0,0,1-1.42,1.422c-.662,0-.39,0-1.052,0-.133,0-.22.009-.271.173a2.556,2.556,0,0,1-4.959-.057.85.85,0,0,0-.043-.1H18.172c-.678,1.56-1.455,2.137-2.77,2.053A2.617,2.617,0,0,1,13.1,12.9c-.168,0-.347,0-.526,0-.824-.014.211.042-.6-.061a2.288,2.288,0,0,1-1.963-2.284q-.019-4.1,0-8.2A2.357,2.357,0,0,1,12.386.007C18.88,0,20.706-.007,27.2.01a6.164,6.164,0,0,1,5.759,4.228c.076.229.171.343.417.3.084-.014.173,0,.259,0a.588.588,0,0,1,.66.428c.153.389.34.765.513,1.146ZM32.333,9.881c-.468-.07-.91-.147-1.356-.2a1.2,1.2,0,0,1-.777-.375c-.444-.464-.95-.872-1.366-1.359a1.865,1.865,0,0,0-1.911-.777,2.32,2.32,0,0,1-.459-.008H19.226c-.163,0-.326.012-.488.011-3.126,0-4.384-.006-7.51-.016-.219,0-.276.068-.273.279.01.988,0,1.975.006,2.963A1.442,1.442,0,0,0,12.5,11.955c.748.012-.371,0,.377.006a.255.255,0,0,0,.3-.223,2.551,2.551,0,0,1,4.919,0,.244.244,0,0,0,.277.211c2.944,0,4.021,0,6.965,0a.255.255,0,0,0,.295-.226,2.46,2.46,0,0,1,1.095-1.461,2.566,2.566,0,0,1,3.821,1.427c.031.1.132.243.2.244.748.017.562.018,1.31,0a.364.364,0,0,0,.264-.235c.023-.6.012-1.2.012-1.82M11,2.246H30.515c-.116-.1-.186-.159-.26-.215A5.352,5.352,0,0,0,26.9.942c-6.329,0-7.989,0-14.317,0a2.537,2.537,0,0,0-.514.048A1.352,1.352,0,0,0,11,2.246M32.335,8.911c0-.973.011-1.912,0-2.85a5.127,5.127,0,0,0-.8-2.636.375.375,0,0,0-.37-.2c-1.17.007-2.34,0-3.51,0-.074,0-.147.011-.222.017V6.22a3.832,3.832,0,0,0,.455,0,1,1,0,0,1,.887.356c.658.671,1.338,1.32,2.016,1.971a.719.719,0,0,0,.338.191c.385.072.776.116,1.2.176m-9.967-5.66h-3.1V6.2h3.1Zm4.073,0h-3.1V6.2h3.1ZM15.186,6.2h3.09V3.24h-3.09Zm-1-2.95H10.982V6.2H14.19Zm13.888,7.572a1.605,1.605,0,0,0-1.6,1.61,1.61,1.61,0,1,0,1.6-1.61M17.232,12.437a1.6,1.6,0,0,0-3.209-.015,1.6,1.6,0,1,0,3.209.015",
    transform: "translate(-0.533 0)",
    fill: "#707070"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVehicleButton);
export default __webpack_public_path__ + "static/media/icon_vehicle_button.e3e8b3834879a89fc5ebf839e48bc90f.svg";
export { ForwardRef as ReactComponent };